// extracted by mini-css-extract-plugin
export default {"l_AlertList_main":"AlertList_l_AlertList_main__HczZH","l_AlertList_emptyDataContainer":"AlertList_l_AlertList_emptyDataContainer__9wRYd"};